// JavaScript file for mine
export const channelCode = 'mine';
